import React from 'react';
import { Link } from 'react-router-dom';
import './EmptyState.css';

const renderAction = (action, className) => {
  if (!action?.label) return null;

  const { label, onClick, to } = action;
  const sharedProps = {
    className,
    onClick,
  };

  if (to) {
    return (
      <Link to={to} {...sharedProps}>
        {label}
      </Link>
    );
  }

  return (
    <button type="button" {...sharedProps}>
      {label}
    </button>
  );
};

const EmptyState = ({
  icon,
  title,
  description,
  primaryAction,
  secondaryAction,
}) => (
  <div className="whatquiz-empty-state">
    {icon ? (
      <div className="whatquiz-empty-state__icon" aria-hidden="true">
        {icon}
      </div>
    ) : null}
    {title ? (
      <h1 className="whatquiz-empty-state__title">{title}</h1>
    ) : null}
    {description ? (
      <p className="whatquiz-empty-state__description">{description}</p>
    ) : null}
    {(primaryAction || secondaryAction) ? (
      <div className="whatquiz-empty-state__actions">
        {renderAction(primaryAction, 'whatquiz-empty-state__primary')}
        {renderAction(secondaryAction, 'whatquiz-empty-state__secondary')}
      </div>
    ) : null}
  </div>
);

export default EmptyState;
